module.exports = __webpack_public_path__ + "assets/images/payspace-not-active-mobile@2x.ef2af50e08f12246bbfa9c3c1a752e8a.webp";